export const COOKIE_NAME_ISLOGEDIN = 'luegoPago_isLoggedIn'
export const COOKIE_NAME_USER = 'luegoPago_user'
// export const COOKIE_DOMAIN = process.env.NODE_ENV === 'development' ? '.qcode.net' : '.qcode.app'
export const COOKIE_DOMAIN = '.qcode.app'
export const COOKIE_ACCESS_TOKEN_NAME = 'access_token'
export const COOKIE_ROLE_NAME = 'role_name'
export const COOKIE_ACCESS_SHOPIFY = 'shopify'
